// Click-to-load facade for the raw YouTube <iframe> in text-and-image.twig.
// Loading the real embed eagerly pulls ~700KB of YouTube's own JS into the
// page before a visitor has shown any intent to watch it.
export default function videoFacade(selector = '[data-video-facade]') {
	document.querySelectorAll(selector).forEach((facade) => {
		facade.addEventListener('click', () => {
			const src = facade.getAttribute('data-video-src');
			if (!src) return;

			const separator = src.includes('?') ? '&' : '?';
			const iframe = document.createElement('iframe');
			iframe.src = src + separator + 'autoplay=1';
			iframe.className = 'w-full aspect-video';
			iframe.setAttribute('frameborder', '0');
			iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
			iframe.setAttribute('allowfullscreen', '');

			facade.replaceWith(iframe);
		}, { once: true });
	});
}
